module.exports = __webpack_public_path__ + "img/time.4ca21eaa.svg";